import { render, staticRenderFns } from "./DiscountSale.vue?vue&type=template&id=642217b0&scoped=true&"
import script from "./DiscountSale.vue?vue&type=script&lang=ts&"
export * from "./DiscountSale.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountSale.vue?vue&type=style&index=0&id=642217b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642217b0",
  null
  
)

export default component.exports